import React, { Component } from 'react';
import IntroText from './IntroText';
class SidePanel extends Component {
    constructor(props) {
        super(props);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDocumentMouseDown = this.onDocumentMouseDown.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', this.onKeyDown);
            document.addEventListener('mousedown', this.onDocumentMouseDown);
        }
        if (prevProps.open && !this.props.open) {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', this.onKeyDown);
            document.removeEventListener('mousedown', this.onDocumentMouseDown);
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('mousedown', this.onDocumentMouseDown);
    }

    onOverlayClick(e) {
        const config = this.props.backgroundClickThroughConfig;
        const isBackgroundClickThroughEnabled = !!(config && config.enabled);
        if (isBackgroundClickThroughEnabled) {
            return;
        }
        if (e.target === e.currentTarget && this.props.onClose) this.props.onClose();
    }

    onKeyDown(e) {
        if (e.key === 'Escape' && this.props.onClose) this.props.onClose();
    }

    onDocumentMouseDown(e) {
        const config = this.props.backgroundClickThroughConfig;
        const isBackgroundClickThroughEnabled = !!(config && config.enabled);
        const shouldIgnoreOutsideClickTarget = config && config.shouldIgnoreOutsideClickTarget;

        if (!this.props.open || !isBackgroundClickThroughEnabled || !this.props.onClose) {
            return;
        }

        const clickedInsidePanel = this.panelRef && this.panelRef.contains(e.target);
        const clickedIgnoredTarget =
            typeof shouldIgnoreOutsideClickTarget === 'function' ? shouldIgnoreOutsideClickTarget(e.target) : false;

        if (!clickedInsidePanel && !clickedIgnoredTarget) {
            this.props.onClose();
        }
    }

    render() {
        const {
            open,
            title = 'List display options',
            width = 375,
            children,
            onClose,
            introText,
            introTextClass,
            backgroundClickThroughConfig
        } = this.props;

        // When enabled, overlay clicks pass through to the page while the side panel remains interactive.
        const isBackgroundClickThroughEnabled = !!(backgroundClickThroughConfig && backgroundClickThroughConfig.enabled);
        const overlayClassName = 'sp' + (open ? ' sp--open' : '');
        const overlayStyle = isBackgroundClickThroughEnabled && open ? { pointerEvents: 'none' } : undefined;
        const panelStyle = {
            width: width,
            pointerEvents: isBackgroundClickThroughEnabled && open ? 'auto' : undefined
        };

        return (
            <div className={'sp-root'}>
                <div
                    className={overlayClassName}
                    style={overlayStyle}
                    onClick={this.onOverlayClick}
                    aria-hidden={!open}
                >
                    <aside
                        className={'sp__panel' + (open ? ' sp__panel--open' : '')}
                        style={panelStyle}
                        ref={node => {
                            this.panelRef = node;
                        }}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="sp-title"
                    >
                        <header className="sp__header">
                            <h1 className="roomView__title">{title}</h1>
                            <div className="sp__cancel" onClick={onClose}>
                                <span className="spark-icon--fill spark-icon-close"></span>
                            </div>
                            <IntroText text={introText} className={introTextClass} />
                        </header>

                        <div className="sp__body">{children}</div>
                    </aside>
                </div>
            </div>
        );
    }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/modals/sidePanel/rightSidePanel.js